/**
 * AuthLayout.
 *
 * Used for login, password reset, and any other pre-auth pages. TNN-branded
 * so a nonprofit logging in feels like they're entering a TNN product, not
 * a generic SaaS shell.
 *
 * Visual structure:
 *   - Soft branded gradient background
 *   - Centered card with TNN logo above the content (Outlet)
 *   - Tagline below the logo so the brand voice carries through
 *   - Footer line at the bottom
 *
 * The Outlet renders the actual page (LoginForm, ForgotPasswordPage, etc).
 * Each page can assume the logo + tagline have already been rendered above
 * it, so the page contents start directly with their own h1.
 */
import { Outlet } from "react-router-dom";

import { TNNLogo } from "@/shared/ui/TNNLogo";

/** TNN-branded shell for pre-auth pages (login, password reset). */
export function AuthLayout() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-background via-secondary to-secondary">
      <div className="flex min-h-screen items-center justify-center px-4 py-12">
        <div className="w-full max-w-md">
          {/* TNN logo lockup - bigger than a footer mention, so the brand */}
          {/* is the first thing the applicant sees */}
          <div className="mb-8 flex flex-col items-center">
            <TNNLogo className="h-10 w-auto text-primary" />
            <p className="mt-3 text-center text-sm text-muted-foreground">
              The operations platform for Tennessee nonprofits
            </p>
          </div>
          <Outlet />
        </div>
      </div>
      <footer className="fixed bottom-4 right-4 text-xs text-muted-foreground/50">
        Tennessee Nonprofit Network · {new Date().getFullYear()}
      </footer>
    </div>
  );
}
